import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import { animated } from "react-spring";
import styles from "./WaitlistForm.module.scss";

type Props = {
  initialPage?: boolean;
};

const ID_PREFIX = "waitlist-form";

function WaitlistForm({ initialPage = true }: Props) {

  
  return (
    <div
  id={`${ID_PREFIX}-container`}
  data-pogr-id={`${ID_PREFIX}-container`}
  className={`${styles.container} flex flex-col md:flex-row items-center`}
>
  {/* Left Side Text */}
  <div className="flex justify-center flex-col md:w-1/2 w-full">
    <p className="!text-[45px] !font-bold">
      We’d Love to Have a Call <br /> With You!
    </p>
    <p className="text-[#9d9dbb] !text-base">
      Let’s schedule a call to explore how we can collaborate in raising <br /> the quality of the gaming world together.
    </p>

    {/* Button */}
    <animated.div>
      <Button
        variant="contained"
        size="large"
        endIcon={<FontAwesomeIcon icon={faCaretRight} height={8} width={6} />}
        className="
          cursor-pointer rounded-lg border-none !bg-[#00DDDD] !mt-8
          px-6 py-3 text-white hover:!text-[#00DDDD] font-medium shadow-md hover:!bg-[#fff]
        "
      >
        Schedule meeting with us
      </Button>
    </animated.div>
  </div>

  {/* Right Side Image (hidden on mobile) */}
  <div className="md:w-1/2 hidden md:flex justify-end items-end">
    <img
      className="w-full h-full object-contain"
      src="/static/features/waitlist-form.svg"
      alt="Waitlist Form"
    />
  </div>
</div>

  );
}

export default WaitlistForm;
